import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { fetchMacroProcesses, fetchTemplatesForPurpose } from '@/features/macro-process-creation/services/macroProcessService'
import { openModal } from '@/features/macro-process-creation/macroProcessCreationSlice'
import { selectIfUserIsAdmin } from '@/features/auth/authSlice'
import { openEditModal } from '@/features/macro-process-edit/macroProcessEditSlice'
import { fetchTemplatesForEdit } from '@/features/macro-process-edit/services/macroProcessEditService'

/**
 * @typedef {Object} MacroProcessButtonsProps
 * @property {number} bienId
 */

const PURPOSES = [
  { key: 'location', label: 'Créer un process de location' },
  { key: 'vente', label: 'Créer un process de vente' },
]

/**
 * Affiche les boutons d'action sur les macro processes d'un bien :
 * - "Créer" si aucun process pending n'existe pour ce purpose
 * - "Ajouter des étapes" si un process pending existe déjà
 *
 * @param {MacroProcessButtonsProps} props
 */
export default function MacroProcessButtons({ bienId }) {
  const dispatch = useDispatch()
  const isAdmin = useSelector(selectIfUserIsAdmin)
  const existingProcesses = useSelector(state => state.macroProcessCreation.existingProcesses || [])

  const getPendingProcessForPurpose = (purpose) =>
    existingProcesses.find(p => p.purpose === purpose && p.status === 'pending') || null

  useEffect(() => {
    dispatch(fetchMacroProcesses({ bien_id: bienId, status: 'pending' }))
  }, [bienId])

  if (!isAdmin) return null

  return (
    <div className="flex gap-2 mb-4 flex-wrap">
      {PURPOSES.map(({ key, label }) => {
        const pendingProcess = getPendingProcessForPurpose(key)

        if (pendingProcess) {
          return (
            <button
              key={key}
              className="btn btn-primary btn-sm"
              onClick={() => {
                dispatch(openEditModal(pendingProcess))
                dispatch(fetchTemplatesForEdit(key))
              }}
            >
              Ajouter des étapes au {pendingProcess.name}
            </button>
          )
        }

        return (
          <button
            key={key}
            className="btn btn-primary btn-sm"
            onClick={() => {
              dispatch(openModal(key))
              dispatch(fetchTemplatesForPurpose(key))
            }}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
